import React, { useState, useEffect, useRef } from "react";
import AdminSettingsDataService from "../../../services/admin-settings.service";
import AdminToolsDataService from "../../../services/admin-tools.service";
import { NotificationManager } from "react-notifications";
import { useSelector } from "react-redux";

import { useTranslation } from "react-i18next";
import { Button, Input, Modal, Select, Table, Tooltip } from "antd";


const { Option } = Select;

export const ApiAccessToken = (props) => {
  const { t } = useTranslation();
  const loginDetials = useSelector((state) => state.loginReducer.loginDetials);
  const ref = useRef(null);
  const [cursor, setCursor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [btndisabled, setBtndisabled] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [retailerList, setRetailerList] = useState([]);
  const [retailerListLoading, setRetailerListLoading] = useState(false);
  const [newToken, setNewToken] = useState({
    dealerId: "",
    apiKey: "",
  });
  const [newTokenVal, setNewTokenVal] = useState({
    dealerIdVal: "",
    apiKeyVal: "",
  });
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteDealerId, setDeleteDealerId] = useState(null);

  useEffect(() => {
    const input = ref.current;
    if (input) input.setSelectionRange(cursor, cursor);
    handleGetApiAccessTokenList();
  }, []);

  const handleGetApiAccessTokenList = () => {
    let inputData = {
      pageNumber: 1,
      pageSize: 100000,
    };
    setLoading(true);
    AdminSettingsDataService.GetApiAccessTokenList(inputData)
      .then((response) => {
        var responseData = response.data.responseData;
        var message = response.data.message;
        if (message === "Success") {
          var filteredData = responseData
            ? responseData.filter(
                (x) =>
                  x.apiAccessToken &&
                  x.apiAccessToken.apiType === "Jewelry"
              )
            : [];
          setTotalCount(filteredData.length);
          setData(filteredData);
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleSaveApiAccessToken = (Id) => {
    var selectedList = [];
    selectedList = data.filter((x) => x.dealerID === Id);
    setSubmitLoading(true);
    AdminSettingsDataService.SaveApiAccessToken(selectedList[0].apiAccessToken)
      .then((response) => {
        var message = response.data.message;
        if (message === "Success") {
          NotificationManager.success(t("Added Successfully."));
          handleGetApiAccessTokenList();
          setBtndisabled(null);
        } else {
          NotificationManager.error(t("Not Added."));
        }
      })
      .catch((error) => {
        setSubmitLoading(false);
        console.log(error);
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  const handleGetRetailerList = () => {
    let dealerId =
      loginDetials?.loginDetials?.responseData?.dealerId || 0;
    let inputData = {
      clientType: "retailer",
      dealerId: Number(dealerId) || 0,
    };
    setRetailerListLoading(true);
    AdminToolsDataService.GetUsersList(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setRetailerList(responseData || []);
        } else {
          setRetailerList([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setRetailerList([]);
      })
      .finally(() => {
        setRetailerListLoading(false);
      });
  };

  const showAddNewModal = () => {
    setNewToken({ dealerId: "", apiKey: "" });
    setNewTokenVal({ dealerIdVal: "", apiKeyVal: "" });
    handleGetRetailerList();
    setIsModalVisible(true);
  };

  const handleCancelModal = () => {
    setIsModalVisible(false);
    setNewToken({ dealerId: "", apiKey: "" });
    setNewTokenVal({ dealerIdVal: "", apiKeyVal: "" });
  };

  const handleNewTokenChange = (e, type, name) => {
    if (type === "select") {
      setNewToken({ ...newToken, [name]: e });
      setNewTokenVal({ ...newTokenVal, [name + "Val"]: "" });
    } else {
      setNewToken({ ...newToken, [e.target.name]: e.target.value });
      setNewTokenVal({ ...newTokenVal, [e.target.name + "Val"]: "" });
    }
  };

  const handleAddNewToken = () => {
    let isValid = true;
    let valObj = { dealerIdVal: "", apiKeyVal: "" };
    if (!newToken.dealerId) {
      valObj.dealerIdVal = t("Please select Retailer.");
      isValid = false;
    }
    if (newToken.dealerId && data.some((x) => String(x.dealerID) === String(newToken.dealerId))) {
      valObj.dealerIdVal = t("This Retailer already has a Jewelry API Access Token.");
      isValid = false;
    }
    if (!newToken.apiKey) {
      valObj.apiKeyVal = t("Please enter API Key.");
      isValid = false;
    }
    if (!isValid) {
      setNewTokenVal(valObj);
      return;
    }
    let inputData = {
      dealerId: newToken.dealerId.toString(),
      apiType: "Jewelry",
      accessToken: newToken.apiKey,
      createdBy: 0,
    };
    setSubmitLoading(true);
    AdminSettingsDataService.SaveApiAccessToken(inputData)
      .then((response) => {
        var message = response.data.message;
        if (message === "Success") {
          NotificationManager.success(t("Added Successfully."));
          handleCancelModal();
          handleGetApiAccessTokenList();
        } else {
          NotificationManager.error(t("Not Added."));
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  const showDeleteModal = (Id) => {
    setDeleteDealerId(Id);
    setIsDeleteModalVisible(true);
  };

  const handleCancelDelete = () => {
    setIsDeleteModalVisible(false);
    setDeleteDealerId(null);
  };

  const handleConfirmDelete = () => {
    setSubmitLoading(true);
    AdminSettingsDataService.DeleteApiAccessToken(deleteDealerId)
      .then((response) => {
        var message = response.data.message;
        if (message === "Success") {
          NotificationManager.success(t("Deleted Successfully."));
          handleGetApiAccessTokenList();
        } else {
          NotificationManager.error(t("Not Deleted."));
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setSubmitLoading(false);
        setIsDeleteModalVisible(false);
        setDeleteDealerId(null);
      });
  };

  const handleOnChange = (e, isSelect, Id, name) => {
    setBtndisabled(Id);
    if (isSelect === "select") {
      const checkData = data;
      if (
        checkData.filter((x) => x.dealerID === Id)[0].apiAccessToken === null
      ) {
        let ObjData = {
          dealerId: Id.toString(),
          apiType: e,
          createdBy: 0,
        };
        checkData.filter((x) => x.dealerID === Id)[0].apiAccessToken = ObjData;
      } else {
        checkData.filter((x) => x.dealerID === Id)[0].apiAccessToken.apiType =
          e;
      }
      setData([...checkData]);
    } else {
      setCursor(e.target.selectionStart);
      const checkData = data.filter((x) => x.dealerID === Id);
      if (checkData[0].apiAccessToken === null) {
        let ObjData = {
          dealerId: Id.toString(),
          accessToken: e.target.value,
          createdBy: 0,
        };
        data.filter((x) => x.dealerID === Id)[0].apiAccessToken = ObjData;
      } else {
        data.filter((x) => x.dealerID === Id)[0].apiAccessToken.accessToken =
          e.target.value;
      }
      setData(data);
    }
  };

  function handlePageNoChange(page, size) {
    var tableBody = document.querySelector(".table__scroll .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    setPageNo(page);
    setPageSize(size);
  }
  function handlePageSizeChange(current, size) {
    setPageNo(1);
    setPageSize(size);
  }

  return (
    <div className="form__fields">
      <div className="row magento__mapping">
        <div className="col-md-12">
          <div className="heading__block mb-3 d-flex justify-content-between align-items-center">
            <h4 class="workarea__heading mt-0 mb-0">
              {" "}
              {t("API Access Token")}{" "}
            </h4>
            <button className="primary-btn" onClick={showAddNewModal}>
              <i className="fa fa-plus-circle mr-1"></i>
              {t("Add New")}
            </button>
          </div>
        </div>
        <div className="divForm form__fields border-0 bg-transparent p-0">
          <div className="table__scroll">
            <Table
              scroll={{ y: "calc(100vh - 340px)" }}
              pagination={{
                size: "small",
                total: totalCount,
                current: pageNo,
                pageSize: pageSize,
                pageSizeOptions: [10, 15, 20, 50, 100],
                responsive: true,
                showSizeChanger: true,
                onChange: handlePageNoChange,
                onShowSizeChange: handlePageSizeChange,
              }}
              loading={loading}
              dataSource={data}
              columns={[
                {
                  title: (
                    <Tooltip title={t("Retailer ID")}>
                      {t("Retailer ID")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "dealerID",
                  key: "dealerID",
                  //fixed: "left",
                },
                {
                  title: (
                    <Tooltip title={t("Retailer Name")}>
                      {t("Retailer Name")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "dealerCompany",
                  key: "retailername",
                  //fixed: "left",
                },
                {
                  title: (
                    <Tooltip title={t("API Type")}>{t("API Type")}</Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "apiAccessToken",
                  key: "apiAccessToken",

                  render: () => {
                    return "Jewelry";
                  },
                },
                {
                  title: <Tooltip title={t("API Key")}>{t("API Key")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "accessToken",
                  key: "apiAccessToken",
                  render: (data, item) => {
                    return (
                      <Input.Password
                        ref={ref}
                        className="apikeytxt"
                        autoComplete="false"
                        value={
                          item?.apiAccessToken?.accessToken
                            ? item?.apiAccessToken?.accessToken
                            : ""
                        }
                        onChange={(e) =>
                          handleOnChange(e, "input", item.dealerID)
                        }
                      />
                    );
                  },
                },
                {
                  title: <Tooltip title={t("Action")}>{t("Action")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "update",
                  key: "update",
                  render: (row, data) => {
                    return (
                      <div className="d-flex align-items-center justify-content-center" style={{ gap: "8px" }}>
                        <button
                          className={
                            btndisabled == data.dealerID
                              ? "primary-btn"
                              : btndisabled == null
                              ? "disabled-btn"
                              : "disabled-btn"
                          }
                          onClick={() => handleSaveApiAccessToken(data.dealerID)}
                          loading={submitLoading}
                          disabled={btndisabled == data.dealerID ? false : true}
                        >
                          {t("Update")}
                        </button>
                        <button
                          className="primary-btn"
                          onClick={() => showDeleteModal(data.dealerID)}
                        >
                          {t("Delete")}
                        </button>
                      </div>
                    );
                  },
                },
              ]}
            />
          </div>
        </div>
      </div>

      <Modal
        title={t("Add New API Access Token")}
        centered
        visible={isModalVisible}
        onCancel={handleCancelModal}
        width={600}
        footer={[
          <Button key="back" onClick={handleCancelModal}>
            {t("Cancel")}
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={submitLoading}
            onClick={handleAddNewToken}
          >
            {t("Save")}
          </Button>,
        ]}
      >
        <div className="form__fields p-0 border-0">
          <div className="row">
            <div className="col-md-12">
              <div className="input__block">
                <label>
                  {t("Retailer")} <span>*</span>
                </label>
                <Select
                  showSearch
                  placeholder={t("Select Retailer")}
                  optionFilterProp="children"
                  value={newToken.dealerId ? newToken.dealerId : null}
                  onChange={(e) =>
                    handleNewTokenChange(e, "select", "dealerId")
                  }
                  loading={retailerListLoading}
                  className={
                    newTokenVal.dealerIdVal ? "border__red" : "border__grey"
                  }
                  filterOption={(input, option) =>
                    (option?.children ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  <Option value="">{t("Select Retailer")}</Option>
                  {retailerList.map((item) => {
                    return (
                      <Option key={item.dealerID} value={item.dealerID}>
                        {item.dealerCompany + " (" + item.dealerID + ")"}
                      </Option>
                    );
                  })}
                </Select>
                {newTokenVal.dealerIdVal && (
                  <p className="error-color-red">{newTokenVal.dealerIdVal}</p>
                )}
              </div>
            </div>
            <div className="col-md-12">
              <div className="input__block">
                <label>
                  {t("API Type")}
                </label>
                <input
                  type="text"
                  value="Jewelry"
                  disabled
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="input__block">
                <label>
                  {t("API Key")} <span>*</span>
                </label>
                <input
                  type="text"
                  placeholder={t("Enter API Key")}
                  name="apiKey"
                  value={newToken.apiKey}
                  onChange={handleNewTokenChange}
                  className={newTokenVal.apiKeyVal ? "border__red" : ""}
                />
                {newTokenVal.apiKeyVal && (
                  <p className="error-color-red">{newTokenVal.apiKeyVal}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        title={t("Delete Confirmation")}
        centered
        visible={isDeleteModalVisible}
        onCancel={handleCancelDelete}
        width={400}
        footer={[
          <Button key="back" onClick={handleCancelDelete}>
            {t("Cancel")}
          </Button>,
          <Button
            key="submit"
            type="primary"
            danger
            loading={submitLoading}
            onClick={handleConfirmDelete}
          >
            {t("Delete")}
          </Button>,
        ]}
      >
        <p>{t("Are you sure you want to delete this API Access Token?")}</p>
      </Modal>
    </div>
  );
};

export default ApiAccessToken;
